import { render, staticRenderFns } from "./xitong-jibing.vue?vue&type=template&id=d67165ea&scoped=true&"
import script from "./xitong-jibing.vue?vue&type=script&lang=ts&"
export * from "./xitong-jibing.vue?vue&type=script&lang=ts&"
import style0 from "./xitong-jibing.vue?vue&type=style&index=0&id=d67165ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67165ea",
  null
  
)

export default component.exports